var map = {
	"./EmergingTech": 240,
	"./EmergingTech.jsx": 240,
	"./cloud-computing": 529,
	"./cloud-computing.js": 529,
	"./consulting-services": 530,
	"./consulting-services.js": 530,
	"./devops": 531,
	"./devops.js": 531,
	"./emergingTechPageComponent": 235,
	"./emergingTechPageComponent.js": 235,
	"./iot-development": 532,
	"./iot-development.js": 532,
	"./it-consulting": 533,
	"./it-consulting.js": 533,
	"./opensource-development": 534,
	"./opensource-development.js": 534,
	"./product-engineering": 535,
	"./product-engineering.js": 535,
	"./qa-testing": 536,
	"./qa-testing.js": 536,
	"./software-maintenance-support": 537,
	"./software-maintenance-support.js": 537,
	"./staff-augmentation-dedicated-teams": 538,
	"./staff-augmentation-dedicated-teams.js": 538,
	"./wearable-app-development": 539,
	"./wearable-app-development.js": 539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;